import type { CSSProperties } from "react";

export const logsCheckModalUi = {
  summary: {
    display: "flex",
    flexWrap: "wrap",
    alignItems: "center",
    justifyContent: "space-between",
    gap: "8px",
    padding: "10px 12px",
    marginBottom: "12px",
    borderRadius: "12px",
    background: "#212529",
    color: "#f8fafc",
  } satisfies CSSProperties,

  summaryName: {
    margin: 0,
    fontSize: "0.9rem",
    fontWeight: 700,
    lineHeight: 1.3,
  } satisfies CSSProperties,

  summaryMeta: {
    margin: 0,
    fontSize: "0.8125rem",
    color: "#cbd5e1",
    fontWeight: 500,
  } satisfies CSSProperties,

  countBadge: {
    display: "inline-flex",
    alignItems: "center",
    gap: "6px",
    padding: "6px 12px",
    borderRadius: "999px",
    background: "rgba(80, 183, 192, 0.2)",
    color: "#5eead4",
    fontSize: "0.75rem",
    fontWeight: 600,
  } satisfies CSSProperties,

  list: {
    display: "flex",
    flexDirection: "column",
    gap: "8px",
  } satisfies CSSProperties,

  loadingWrap: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    padding: "24px 12px",
    color: "#64748b",
  } satisfies CSSProperties,

  emptyWrap: {
    textAlign: "center",
    padding: "24px 12px",
    color: "#64748b",
  } satisfies CSSProperties,

  item: {
    borderRadius: "12px",
    border: "1px solid #e2e8f0",
    background: "#ffffff",
    overflow: "hidden",
    boxShadow: "0 1px 3px rgba(15, 23, 42, 0.06)",
  } satisfies CSSProperties,

  itemHeader: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: "8px",
    width: "100%",
    padding: "8px 12px",
    border: "none",
    background: "#ffffff",
    cursor: "pointer",
    textAlign: "left",
  } satisfies CSSProperties,

  itemHeaderStatic: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: "8px",
    padding: "8px 12px",
  } satisfies CSSProperties,

  time: {
    fontSize: "1rem",
    fontWeight: 700,
    color: "#0f766e",
    fontVariantNumeric: "tabular-nums",
    letterSpacing: "0.02em",
  } satisfies CSSProperties,

  badgeOk: {
    display: "inline-flex",
    alignItems: "center",
    gap: "5px",
    padding: "4px 10px",
    borderRadius: "999px",
    background: "#ecfdf5",
    color: "#047857",
    fontSize: "0.75rem",
    fontWeight: 600,
  } satisfies CSSProperties,

  badgeWarn: {
    display: "inline-flex",
    alignItems: "center",
    gap: "5px",
    padding: "4px 10px",
    borderRadius: "999px",
    background: "#fffbeb",
    color: "#b45309",
    fontSize: "0.75rem",
    fontWeight: 600,
  } satisfies CSSProperties,

  chevron: {
    color: "#64748b",
    fontSize: "0.875rem",
    transition: "transform 0.2s ease",
  } satisfies CSSProperties,

  mapWrap: {
    padding: "0 12px 10px",
    borderTop: "1px solid #f1f5f9",
  } satisfies CSSProperties,

  mapFrame: {
    border: 0,
    borderRadius: "10px",
    width: "100%",
    height: 220,
  } satisfies CSSProperties,
} as const;

export function parseCheckCoords(coordsStr?: string | null): {
  latitude: number | null;
  longitude: number | null;
} {
  if (!coordsStr) {
    return { latitude: null, longitude: null };
  }
  try {
    const parsed = JSON.parse(coordsStr) as Record<string, unknown>;
    const lat = parsed?.latitude ?? parsed?.lat;
    const lng = parsed?.longitude ?? parsed?.lng ?? parsed?.lon;
    const latitude =
      lat != null && lat !== "" && !Number.isNaN(Number(lat))
        ? Number(lat)
        : null;
    const longitude =
      lng != null && lng !== "" && !Number.isNaN(Number(lng))
        ? Number(lng)
        : null;
    return { latitude, longitude };
  } catch {
    return { latitude: null, longitude: null };
  }
}

export function hasValidCoords(
  coords: ReturnType<typeof parseCheckCoords>
): boolean {
  return (
    coords.latitude != null &&
    coords.longitude != null &&
    Number.isFinite(coords.latitude) &&
    Number.isFinite(coords.longitude)
  );
}
